export default {
  physicianData: (state) => state.data.physicianData,
  clinicData: (state) => state.data.clinicData,
  trackingData: (state) => state.data.trackingData ?? {},
}
